module.exports = __webpack_public_path__ + "static/media/3.6ad318be.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/3.png
// module id = 2110
// module chunks = 0